// Paywall carousel — hero images shown behind the iOS paywall sheet
// (PX-254). Thin wrapper over the shared MediaCarouselManager; CRUD hits
// /admin/paywall-images (PX-250), each mutation invalidates the public
// paywall:config Redis cache server-side. Uploads ride through
// MediaDropzone → /admin/media/upload (PX-247), persisting only the URL.

import { MediaCarouselManager } from '@/components/MediaCarouselManager'
import { PERM } from '@/types/api'

export function PaywallCarouselPage() {
  return (
    <MediaCarouselManager
      title="Paywall carousel"
      description="Hero images shown behind the paywall sheet. Order by sort value; toggle Active to hide without deleting. Takes effect without an app release."
      endpoint="/admin/paywall-images"
      queryKey={['admin', 'paywall-images']}
      writePerm={PERM.paywall_images_write}
      deleteConfirmText="Delete this paywall-carousel image? This removes it permanently."
    />
  )
}
